export default __webpack_public_path__ + "static/media/python.6a8b2999.svg";